"use client";
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Card, Divider } from "semantic-ui-react";
import { ImageItem, ListItems, Title } from "../../../components";
import { styles } from "./element";

import { Carousel } from "react-responsive-carousel";

// let url = window.location.origin;
const finalurl = "/?address=San Francisco, CA, USA";

const LandingGrids = ({ gridData, urls, ispage, handleClick, isMobile }) => {
  const [hovered, setHovered] = useState(false);
  useEffect(() => {
    const interval = setInterval(() => {
      setAnimationIndex((prevIndex) =>
        prevIndex === null ? 0 : (prevIndex + 1) % gridData.length,
      );
    }, 2000);

    return () => clearInterval(interval);
  }, []);
  const handleLinkClick = () => {
    if (ispage === "nhmap") {
      handleClick();
    } else {
      window.location.href = finalurl;
    }
  };
  const [animationIndex, setAnimationIndex] = useState(null);

  const renderCard = (grid, index) => (
    <div
      className="card_nhmap"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <Card
        raised
        key={index}
        style={{
          ...styles,
          animation:
            !isMobile &&
            !hovered &&
            ispage === "nhmap" &&
            index === animationIndex
              ? "zoomInOut 2s infinite"
              : "none",
        }}
        className="cardWithAnimation"
      >
        <Card.Content>
          <div style={{ height: "100px" }}>
            <ImageItem
              source={process.env.NEXT_PUBLIC_CDN_ID + grid.topHeaderImage}
              style={{ height: "100px" }}
              title={grid.topHeaderContent}
              alt={grid.topHeaderContent}
            />
          </div>
          {/* <Divider hidden /> */}
          <Card.Header>
            <Title
              size="small"
              name={grid.topHeaderContent}
              style={{
                color: "#1b57a5",
                letterSpacing: 0.3,
                margin: 7,
              }}
            />
          </Card.Header>
          {/* <Divider hidden /> */}
          <Card.Meta>{grid.headerContent}</Card.Meta>
          <Card.Description>
            <ListItems {...grid} url={urls} />
          </Card.Description>
        </Card.Content>
      </Card>
    </div>
  );

  return (
    <>
      {isMobile ? (
        <Carousel
          showStatus={false}
          autoPlay={false}
          className="landing-grids-Carousel"
          selectedItem={animationIndex}
        >
          {gridData.map((grid, index) => renderCard(grid, index))}
        </Carousel>
      ) : (
        <a onClick={() => handleLinkClick()}>
          <Card.Group centered>
            {gridData.map((grid, index) => renderCard(grid, index))}
          </Card.Group>
        </a>
      )}
    </>
  );
};

LandingGrids.propTypes = {
  gridData: PropTypes.array.isRequired,
};

export default LandingGrids;
